exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divBox[data-v-13012cae]  .el-badge__content.is-fixed.is-dot{right:1px;top:5px}", ""]);

// exports
